import { render, staticRenderFns } from "./AdminImportReports.vue?vue&type=template&id=65d59985&scoped=true&"
import script from "./AdminImportReports.vue?vue&type=script&lang=js&"
export * from "./AdminImportReports.vue?vue&type=script&lang=js&"
import style0 from "./AdminImportReports.vue?vue&type=style&index=0&id=65d59985&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d59985",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65d59985')) {
      api.createRecord('65d59985', component.options)
    } else {
      api.reload('65d59985', component.options)
    }
    module.hot.accept("./AdminImportReports.vue?vue&type=template&id=65d59985&scoped=true&", function () {
      api.rerender('65d59985', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminImportReports.vue"
export default component.exports